import { Col, Form, Row, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaInput } from "apps/Common/MazakaInput";
import useMazakaForm from "hooks/useMazakaForm";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { forgotPassword } from "apps/Account/Services";
import { FC } from "react";
import { ForgotPasswordProps } from "apps/Account/Modesl";

const ForgotPassword: FC<ForgotPasswordProps> = (props) => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const { Text } = Typography;

  const handleOnFinish = async () => {
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue();

    try {
      const response: any = await forgotPassword(formValues);
      mazakaForm.setSuccess(1000, () => "E-Postanıza link gönderildi");
      props.setLoginType("email");
      props.setIsShowForgotPassword(false);
      props.onFinish();
      openNotificationWithIcon("default", response?.message);
    } catch (error: any) {
      mazakaForm.setFailed(
        2000,
        error?.message || error?.Value?.Message || "Email ve ya şifre hatalı"
      );
      openNotificationWithIcon(
        "default",
        error?.message || error?.Value?.Message || "Email ve ya şifre hatalı"
      );

      console.log("Somethings wrong during login to dashboard", error);
    }
  };

  return (
    <>
      <Col span={24}>
        <MazakaForm
          submitButtonVisible={false}
          form={form}
          onFinish={handleOnFinish}
        >
          <Row gutter={[10, 20]} className="!px-4">
            
                <MazakaInput
                  xs={24}
                  name={"email"}
                  label={"E-Posta "}
                  inputClassName="!bg-[#f7f7f7] !p-2"
                  placeholder="E-Posta"
                  rules={[{ required: true, message: "" }]}
                />
               
              

            <Col span={24}>
            <Row gutter={[0,20]}>
              <Col xs={24} >
              <MazakaButton
                className="!p-4 !bg-[#FFC502] !text-black"
                htmlType="submit"
                block
                processType={formActions.submitProcessType}
              >
                E-Posta Gönder
              </MazakaButton>

              </Col>
              <Col xs={24} className="!flex justify-center">
                  <Text
                    onClick={() => {
                      props.setIsShowForgotPassword(false);
                    }}
                    className="!text-xs !text-indigo-500 hover:cursor-pointer"
                  >
                    Giriş Yap
                  </Text>
                </Col>
            </Row>
            </Col>
          </Row>
        </MazakaForm>
      </Col>
    </>
  );
};

export default ForgotPassword;
